// extracted by mini-css-extract-plugin
export default {"sections":"NotFound_sections__aDDel"};